import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function EditarInstitucion(props) {
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const [institucion, setInstitucion] = useState({});

  const [form, setForm] = useState({
    direccion: "",
    telefono: "",
    correo: "",
    mision: "",
    vision: "",
    principios: "",
    valores: "",
    objetivosEstrategicos: "",
    politicaSeguridad: "",
  });

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/Api/ObtenerInstitucionesPorId?Id=" +
        props.idIntitucion,
    })
      .then((res) => {
        setInstitucion(res.data);

        setForm({
          direccion: res.data.direccion || "",
          telefono: res.data.telefono || "",
          correo: res.data.correo || "",
          mision: res.data.mision || "",
          vision: res.data.vision || "",
          principios: res.data.principios || "",
          valores: res.data.valores || "",
          objetivosEstrategicos: res.data.objetivosEstrategicos || "",
          politicaSeguridad: res.data.politicaSeguridad || "",
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.idIntitucion]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const postData = async (e) => {
    e.preventDefault();

    try {
      const dataFinal = {
        ...institucion,
        ...form,
      };

      await axios({
        method: "put",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ActualizaInstitucion?Id=" +
          props.idIntitucion,
        data: dataFinal,
      });

      alert("Actualizado con éxito!");
      window.location.reload();
    } catch (error) {
      console.log(error);
      alert("Error al actualizar");
    }
  };

  return (
    <div>
      <button className="btn btn-warning" onClick={openModal}>
        Editar
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Editar Institucion"
      >
        <div className="container">
          <h5 className="text-primary mb-4">Editar Institución</h5>

          <form onSubmit={postData}>
            <div className="form-group mb-3">
              Dirección
              <textarea
                className="form-control"
                name="direccion"
                value={form.direccion}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              Teléfono
              <input
                type="number"
                className="form-control"
                name="telefono"
                value={form.telefono}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              Correo
              <input
                type="email"
                className="form-control"
                name="correo"
                value={form.correo}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              Misión
              <textarea
                className="form-control"
                name="mision"
                value={form.mision}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              Visión
              <textarea
                className="form-control"
                name="vision"
                value={form.vision}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              Principios
              <textarea
                className="form-control"
                name="principios"
                value={form.principios}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              Valores
              <textarea
                className="form-control"
                name="valores"
                value={form.valores}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              Objetivos Estratégicos
              <textarea
                className="form-control"
                name="objetivosEstrategicos"
                value={form.objetivosEstrategicos}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              Política de Seguridad
              <textarea
                className="form-control"
                name="politicaSeguridad"
                value={form.politicaSeguridad}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="btn btn-primary w-100">
              Guardar
            </button>
          </form>
        </div>
      </ReactModal>
    </div>
  );
}

export default EditarInstitucion;
